import { getWithMenu, putWithMenu } from "../../helpers";
import { AkunApiPath, ManajemenAreaApiPath, ManajemenKelompokApiPath, MenuApiPath, UserApiPath, MenuIds, } from "../../../constants";
// --- Akun ---
export const getSearchAkun = async (searchParams) => {
    return await getWithMenu(AkunApiPath, MenuIds.MANAJEMEN.APLIKASI.AKUN.id, { page: 0, size: 500, ...searchParams });
};
// --- Area ---
export const getSearchArea = async (searchParams) => {
    return await getWithMenu(ManajemenAreaApiPath, MenuIds.MANAJEMEN.TRANSAKSI.AREA.id, { page: 0, size: 500, ...searchParams });
};
// --- Kelompok ---
export const getSearchKelompok = async (searchParams) => {
    return await getWithMenu(ManajemenKelompokApiPath, MenuIds.MANAJEMEN.TRANSAKSI.KELOMPOK.id, { page: 0, size: 500, ...searchParams });
};
// --- Menu ---
export const getMenusByUser = async () => {
    const res = await getWithMenu(`${MenuApiPath}/by-user`, MenuIds.MANAJEMEN.APLIKASI.MENU.id);
    return res.data;
};
// --- User ---
export const getSearchUsers = async (searchParams) => {
    return await getWithMenu(UserApiPath, MenuIds.MANAJEMEN.APLIKASI.USER.id, { page: 0, size: 500, ...searchParams });
};
export const getUserById = async (idUser) => {
    return await getWithMenu(`${UserApiPath}/${idUser}`, MenuIds.MANAJEMEN.APLIKASI.USER.id);
};
export const updateUser = async (idUser, payload) => {
    return await putWithMenu(`${UserApiPath}/${idUser}`, MenuIds.MANAJEMEN.APLIKASI.USER.id, payload);
};
